import { useMemo } from "react";
import { generateColumnsDefaultConfiguration } from "../../../components/dataGrid/columnHelpers";
import { formatCurrency } from "../../../utils/mathUtils";

export const useGetBitacoraColumns = (mostrarColumnasPrecios) => {

    const columns = useMemo(() => [
        { headerName: '#', field: 'idBitacora', flex: 8 },
        { headerName: '# Usuario', field: 'idUsuario', flex: 8 },
        { headerName: 'Usuario', field: 'nombreCompletoUsuario', flex: 10 },
        { headerName: 'Fecha', field: 'fecha', flex: 12 },
        { headerName: 'Acción', field: 'accionCompleta', flex: 20 },
        { headerName: 'Descripción', field: 'descripcion', flex: 70 },
        ...(mostrarColumnasPrecios ? [
            { headerName: 'Precio Anterior', field: 'precioAnterior', flex: 10, valueGetter: (data) => (formatCurrency(data)) },
            { headerName: 'Precio Nuevo', field: 'precioNuevo', flex: 10, valueGetter: (data) => (formatCurrency(data)) }]
            : [])
    ], [mostrarColumnasPrecios]);

    return {
        dataGridColumns: generateColumnsDefaultConfiguration(columns),
        excelColumns: columns.map(col => ({ headerName: col.headerName, field: col.field }))
    }
}